import { MAP_PIN_TYPE_ALPHA, MAP_PIN_TYPE_NUMERIC } from '../../modules/theme/map';
import useCurrentPage from './useCurrentPage';

const convertNumToChar = int => (
  String.fromCharCode(int + 65)
);

const useMapPinSecondaryLabel = (index) => {
  const { secondaryFontFamilyClass, secondaryMapPinType } = useCurrentPage();

  let text;

  if (secondaryMapPinType === MAP_PIN_TYPE_ALPHA) {
    text = convertNumToChar(index);
  } else if (secondaryMapPinType === MAP_PIN_TYPE_NUMERIC) {
    text = index + 1;
  }

  return [text, secondaryFontFamilyClass];
};

export default useMapPinSecondaryLabel;
